
// Max file size (5 MB)
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // bytes

// Allowed extensions + MIME types
export const ALLOWED_FILE_TYPES: Record<string, string[]> = {
  jpg: ["image/jpeg"],
  jpeg: ["image/jpeg"],
  png: ["image/png"],
  bmp: ["image/bmp"],
  tiff: ["image/tiff"],
  webp: ["image/webp"],
  ico: ["image/x-icon"],
  pdf: ["application/pdf"],
  txt: ["text/plain"],
  html: ["text/html"],
  xml: ["application/xml", "text/xml"],
  json: ["application/json"],
  doc: ["application/msword"],
  docx: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  csv: ["text/csv"],
  md: ["text/markdown"],
  zip: ["application/zip", "application/x-zip-compressed"],
  gz: ["application/gzip"],
  parquet: ["application/octet-stream", "application/x-parquet", ""],
  xls: ["application/vnd.ms-excel"],
  xlsx: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
};


export const allowedExtensions = [".xlsx", ".xls", ".csv"];
export const allowedMimeTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/csv",
];
